module.exports = __webpack_public_path__ + "media/images/emblems/Chamoson-coat_of_arms-e0b2df7a93ca6f3402aff648e3f46f06.svg";